import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import TioPagTabsTab from './tabs/tab.gts';
import type { ComponentLike } from '@glint/template';
import type { TioPageTabsTabSignature } from './tabs/tab.ts';

interface TioPageTabsSignature {
  Blocks: {
    default: [{ tab: ComponentLike<TioPageTabsTabSignature> }];
  };
  Element: HTMLUListElement;
}

const TioPageTabsComponent: TOC<TioPageTabsSignature> = <template>
  <ul class="flex mb-4" role="navigation" ...attributes>
    {{yield (hash tab=(component TioPagTabsTab))}}
  </ul>
</template>;

export default TioPageTabsComponent;
